<template>
  <div class="product-catalog">
    <div class="category-tabs">
      <a
        v-for="category in categories"
        :key="category.id"
        :class="['category-tab', { active: currentCategory === category.id }]"
        :aria-current="currentCategory === category.id ? 'true' : undefined"
        :href="`#${sectionId}-${category.id}`"
        @click="select(category.id)"
      >{{ category.name }}</a>
    </div>

    <!-- 两个系列都直接展开（六款默认可见，禁 JS 与抓取也能拿到全部卡片）；分类按钮只做锚点定位与高亮。 -->
    <div v-for="category in categories" :key="category.id" class="product-section-wrap">
      <div
        :id="`${sectionId}-${category.id}`"
        class="product-section"
      >
        <ul class="product-grid">
          <li class="product-card" v-for="product in category.items" :key="product.id">
            <div class="product-image" :class="{ 'no-image': !product.image }">
              <img v-if="product.image" :src="product.image" :alt="product.title" loading="lazy" width="300" height="200">
              <span v-else class="no-image-text">该规格暂未取得包装实拍图</span>
            </div>
            <div class="product-info">
              <h3><a :href="detailHref(product.id)">{{ product.title }}</a></h3>
              <ul class="card-facts">
                <li v-for="spec in product.spec" :key="spec">{{ spec }}</li>
                <li>配料：{{ product.ingredients }}</li>
              </ul>
              <a class="explore-btn" :href="detailHref(product.id)">查看详情</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { productCatalog, productDetailHref } from '@/config/products';

export default {
  name: 'ProductCatalog',
  props: {
    // 同一页面可能出现两次（如匠心产品页），锚点前缀必须唯一。
    sectionId: { type: String, default: 'catalog' }
  },
  data() {
    return {
      currentCategory: productCatalog[0] ? productCatalog[0].id : '',
      categories: productCatalog
    }
  },
  methods: {
    /**
     * 高亮后滚到该系列区块。不禁用默认行为：href 本身就是可用锚点，
     * 禁 JS 或抓取时点击仍能定位，这里只补一次显式滚动保证在视口内。
     * @param {string} id
     */
    select(id) {
      this.currentCategory = id
      const target = document.getElementById(`${this.sectionId}-${id}`)
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    /**
     * @param {string} id
     * @returns {string}
     */
    detailHref(id) {
      return productDetailHref(id)
    }
  }
}
</script>

<style scoped>
.category-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 0 0 14px;
}

.category-tab {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 8px 16px;
  border: 2px solid #4b0082;
  border-radius: 30px;
  background: transparent;
  color: #4b0082;
  font-size: 0.92em;
  text-decoration: none;
}

.category-tab.active {
  background: #4b0082;
  color: #fff;
}

.product-section + .product-section {
  margin-top: 16px;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.product-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(75, 0, 130, 0.08);
}

.product-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: #f5f0ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-image-text {
  color: #8a7fa0;
  font-size: 0.85em;
  padding: 0 12px;
  text-align: center;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  padding: 14px;
}

.product-info h3 {
  color: #4b0082;
  font-size: 1.02em;
  margin: 0 0 6px;
}

.product-info h3 a {
  color: #4b0082;
  text-decoration: none;
}

.product-info h3 a:hover {
  text-decoration: underline;
}

.card-facts {
  list-style: none;
  padding: 0;
  margin: 0 0 10px;
  color: #444;
  font-size: 0.9em;
  line-height: 1.7;
}

.explore-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 8px 18px;
  border-radius: 24px;
  background: #4b0082;
  color: #fff;
  text-decoration: none;
  font-size: 0.92em;
}
</style>
